// extracted by mini-css-extract-plugin
module.exports = {"bold":"w0_wy","count":"w0_w1"};